import { ButtonBase, Flex, Image, ImageLightbox, Text } from '@shared/components';
import { useDisclosure } from '@shared/hooks';

export interface CertificateTemplatePreviewerProps {
  previewSrc: string;
  fullSrc: string;
}

export default function CertificateTemplatePreviewer(
  props: Readonly<CertificateTemplatePreviewerProps>,
) {
  const { previewSrc, fullSrc } = props;

  const [
    isCertificateTemplatePreviewerOpen,
    { open: openCertificateTemplatePreviewer, close: closeCertificateTemplatePreviewer },
  ] = useDisclosure();

  return (
    <>
      <ImageLightbox
        open={isCertificateTemplatePreviewerOpen}
        onClose={closeCertificateTemplatePreviewer}
        src={fullSrc}
        alt='Image'
      />
      <Flex
        sx={{
          flexDirection: 'column',
          gap: (theme) => theme.spacing(2),
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Text variant='body1Semibold'>Example Template</Text>
        <Image
          src={previewSrc}
          alt='Image'
          sx={{ height: '148px', width: 'auto', objectFit: 'contain' }}
        />
        <ButtonBase
          onClick={openCertificateTemplatePreviewer}
          type='button'
          sx={{
            cursor: 'pointer',
          }}
        >
          <Text
            component='span'
            sx={{ color: (theme) => theme.palette.info.dark }}
            variant='caption'
          >
            คลิกเพื่อขยาย
          </Text>
        </ButtonBase>
      </Flex>
    </>
  );
}
